module.exports = __webpack_public_path__ + "static/img/certificate03.0739e01b.jpeg";